import './App.css';
import Yahtzee from './Yahtzee'

function App() {
    return (
        <div className="App">
            <Yahtzee />
        </div>
    );
}

export default App;
